import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-root',
  styles: [
    `
      .modal-container {
        padding: 22px 20px 24px 20px;
      }

      .title {
        margin-bottom: 22px;
        font-weight: bold;
        font-size: 20px;
        line-height: 28px;
        letter-spacing: -0.04em;
        color: var(--grey-80);
      }
      .description-wrapper {
      }
      .description ~ .description {
        margin-top: 4px;
      }
      .description {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.02em;
        color: var(--grey-60);
      }
      .modal-button {
        margin-top: 28px;
        padding: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border-radius: 12px;
        background-color: var(--grey-80);
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.03em;
        color: #fffefd;
      }
      .logo-text {
        font-family: 'Kanit';
        font-style: italic;
        font-weight: bold;
        margin-right: 4px;
      }
    `,
  ],
  template: `
    <div class="modal-container">
      <div class="title">{{ '타입스 앱을 이용해 보세요' | locale }}</div>
      <div class="description-wrapper">
        <ng-container *ngFor="let description of descriptions">
          <div class="description">- {{ description | locale }}</div>
        </ng-container>
      </div>
      <button class="modal-button" appLink log-id="lead_to_app_modal" [appLinkPath]="this.path" [buttonType]="'modal'">
        <span class="logo-text">types</span>
        {{ '앱으로 편하게 즐기기' | locale }}
      </button>
    </div>
  `,
})
export class LeadToAppModalComponent {
  constructor() {}

  @Input() descriptions: string[] = [
    '누군가 내 퀴즈에 응답하면 알림을 받을 수 있어요',
    '더 쾌적한 환경에서 타입스를 즐기세요',
  ]
  @Input() path: string | undefined

  ngOnInit(): void {
    if (this.path === undefined) {
      let currentPath = window.location.pathname
      currentPath = currentPath === '/profile' ? 'gnb/profile' : currentPath
      currentPath = currentPath.includes('/personality/test/') ? 'personality/test' : currentPath

      this.path = currentPath
      if (currentPath.startsWith('/')) {
        this.path = this.path.substring(1, this.path.length)
      }
      this.path += window.location.search
    }
  }
}
